export enum AssignmentSections {
  AllAssignments = 'all',
  Drafts = 'drafts',
  Templates = 'templates',
  Partner = 'partner',
}
